<div class="page-title">Ações de Glampoints</div>

<app-table
  [lazy]="false"
  [elements]="actions"
  [cols]="columns"
  [actionButtons]="actionButtons"
  [defaultRows]="25"
  sortField="id"
  [sortOrder]="-1"
  modelName="ações"
  addLabel="Nova ação"
  [addButtonRouterLink]="'new'"
/>
